import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { BvMainClientPlugin } from '@dinosband/bv-main-client/src/vue'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export interface RootState {
  version: string
}

const options: StoreOptions<RootState> = {
  modules: {
  },
  // ,
  // plugins: [createPersistedState()]
}

export const store = new Vuex.Store(options)

// Just for error avoidance
Vue.use(BvMainClientPlugin, {
  httpURI: '',
  wsURI: '',
  restURI: '',
})